/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action, ObservableMap, toJS } from 'mobx';
import tutorialsData from '../pages/helpCenter/sections/tutorials/tutorials.json';
const storageKey = '___nunchee___cm____tutorialsStore';

class TutorialsStore {
    @observable
    hiddenTutorialsMap = {};
    @observable
    tutorials = tutorialsData.items;
    @observable
    details = new ObservableMap();

    constructor() {
        this.load();
    }

    @action
    reset = () => {
        this.hiddenTutorialsMap = {};
        this.tutorials = tutorialsData.items;
        this.details.clear();
    };

    @action
    setAsHidden(_id = 0) {
        this.hiddenTutorialsMap[String(_id)] = true;
        this.save();
    }

    @action
    setAsVisible(_id = 0) {
        this.hiddenTutorialsMap[String(_id)] = false;
        this.save();
    }

    save() {
        try {
            localStorage.setItem(storageKey, JSON.stringify(toJS(this.hiddenTutorialsMap)));
        } catch (e) {
            console.warn(e);
        }
    }

    load() {
        try {
            this.hiddenTutorialsMap = JSON.parse(localStorage.getItem(storageKey)) || {};
        } catch (e) {
            console.warn(e);
        }
    }

    tutorialIsVisible(_id = -1) {
        return !!!this.hiddenTutorialsMap[String(_id)];
    }
}

export default new TutorialsStore();
